import { mapEventToGA4Ecommerce } from '../gtm/ga4-ecommerce';

const MOBILE_EVENT_NAME_MAP = {
    EXECUTED_SEARCH: 'search_hotel',
    SEARCH_WITHOUT_RESULTS: 'search_hotel',
    SEARCH_WITHOUT_RESULTS_HOTEL: 'search_hotel',
    RESULTS_RECEIVED_HOTELS: 'view_item_list',
    SELECTED_HOTEL: 'select_item',
    VIEWED_HOTEL_PAGE: 'view_item',
    SELECTED_DEAL: 'add_to_cart',
    PROCEEDED_TO_PAYMENT_OPEN_PAYMENT_FORM: 'begin_checkout',
    BOOKING_CREATED: 'purchase',
    RESERVATION_CANCELED: 'refund',
};

const PAGE_TYPE_MAP = {
    search_hotel: 'search hotel page',
    view_item_list: 'hotel results page',
    select_item: 'hotel results page',
    view_item: 'hotel page',
    add_to_cart: 'hotel page',
    begin_checkout: 'hotel page',
    purchase: 'hotel page',
    refund: 'my bookings',
};

function isElalMobileWebview() {
    return typeof navigator !== 'undefined' && navigator.userAgent.includes('ElalMobile');
}

function toFirebaseMobileEvent(event_name, properties) {
    const mobileName = MOBILE_EVENT_NAME_MAP[event_name];
    if (!mobileName) return null;

    const ga4 = mapEventToGA4Ecommerce(event_name, properties);
    if (!ga4) return null;

    const { event: _event, event_name: _event_name, ecommerce, email: _email, ...rest } = ga4;

    const params = {
        category: 'EL AL Travel',
        process: 'arbitrip funnel',
        page_url: typeof window !== 'undefined' ? window.location.href : undefined,
        page_type: PAGE_TYPE_MAP[mobileName],
        ...rest,
        ...(ecommerce || {}),
    };

    Object.keys(params).forEach((k) => {
        if (params[k] === undefined || params[k] === null) delete params[k];
    });

    return { name: mobileName, params };
}

export function startSession() {}

export function trackEvent(event_name, properties) {
    try {
        if (!isElalMobileWebview()) return;
        if (typeof window === 'undefined') return;

        const firebaseEvent = toFirebaseMobileEvent(event_name, properties);
        if (!firebaseEvent) return;

        window.postMessage(
            JSON.stringify({ type: 'firebase_event', payload: firebaseEvent }),
            '*'
        );
    } catch (_err) {
        // intentionally ignored
    }
}

export function endSession() {}
